import { parseDate } from "./Tender";

export interface Coupon {
	Code: string;
	CodeFormatted: string;
	PercentageDiscount: number;
	Enabled: boolean;
	DateCreatedUtc: Date;
	CreatedByUserId: string;
	CustomCode: string;
	StartDateUtc: string | null;
	EndDateUtc: string | null; 
	RedemptionCount: number;
	BookId: number;
	Book: string;
	TypeId: CouponType;
	Type: string;
}

export class CreateCouponModel {
	public PercentageDiscount: number;
	public StartDateUtc: Date | null;
	public EndDateUtc: Date | null;
	public RedemptionCount: number;
	public BookId: number;
	public Books: boolean;
}

export class EditCouponModel extends CreateCouponModel {
	public Code: string;
	public PercentageDiscount: number;
	public Enabled: boolean;
	public StartDateUtc: Date | null; 
	public EndDateUtc: Date | null;
	public RedemptionCount: number;
	constructor(coupon?: Coupon) {
		super();
		this.Code = coupon && coupon.Code;
		this.PercentageDiscount = coupon && coupon.PercentageDiscount;
		this.Enabled = coupon && coupon.Enabled;
		this.StartDateUtc = (coupon.StartDateUtc !== null) ? parseDate(coupon.StartDateUtc) : null;
		this.EndDateUtc = (coupon.EndDateUtc !== null) ? parseDate(coupon.EndDateUtc) : null;
		this.RedemptionCount = coupon && coupon.RedemptionCount;
		this.BookId = coupon && coupon.BookId;
		this.Books = coupon && coupon.TypeId === CouponType.Books;
	}
}

export class RedeemResponse {
	public Success: boolean;
	public DiscountMultiplier: number;
	public Error: string;
}

export enum CouponType {
	Cart = 1,
	Books = 2
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/Coupon.ts